export default __webpack_public_path__ + "static/HalvarBreit-Bd-f2aee44f179dd199c080533e4b5f30e3.woff";